import { Box, BoxProps, Typography } from '@mui/material';

type CardTypes = {
    heading?: string;
    containerStyle?: BoxProps;
};

export const Card: React.FC<CardTypes> = ({ children, heading, containerStyle }) => {
    return (
        <Box
            borderRadius="16px"
            paddingX="24px"
            paddingY="32px"
            border="1px solid #FEE380"
            {...containerStyle}
        >
            {heading && (
                <Typography
                    fontSize="24px"
                    color="#1D1D1B"
                    lineHeight="34px"
                    fontWeight="500"
                    marginBottom="24px"
                >
                    {heading}
                </Typography>
            )}
            {children}
        </Box>
    );
};
